import React from "react";
import { Modal, Button } from "antd";
import { InfoCircleFilled } from "@ant-design/icons";
import { InjectBaseModalProps } from "@/hooks/Modal/ModalStore";
import { PrintCheckResult } from "../types";

interface ForbiddenPrintRuleModalProps extends InjectBaseModalProps {
    result: PrintCheckResult;
    onContinue(): void;
}

const ForbiddenPrintRuleModal: React.FC<ForbiddenPrintRuleModalProps> = (props) => {
    const { result, onContinue, onCancel, open } = props;
    const isAllForbidden = result.forbiddenOrderIds.size === result.totalOrders.length;

    return (
        <Modal
            open={open}
            className="print-check-modal"
            styles={{ body: { padding: "4px 32px 16px" } }}
            title={
                <div className="fb" style={{ display: "flex" }}>
                    <InfoCircleFilled style={{ color: "#faad14", marginTop: "3px" }} className="mr10" />
                    您选择的订单包含
                    {result.forbidden.map((item) => item.rule.label).join("，")}
                    的订单
                </div>
            }
            footer={null}
            closable={false}
            onCancel={onCancel}
            width={450}
        >
            <p className="error fb" style={{ padding: "5px 20px" }}>
                这些订单无法打印，会排除不打印
            </p>
            <div style={{ display: "flex", justifyContent: "flex-end", padding: "10px 2px 0 0" }}>
                {isAllForbidden ? (
                    <Button onClick={onCancel}>关闭</Button>
                ) : (
                    <>
                        <Button onClick={onCancel} style={{ marginRight: 12 }}>
                            取消
                        </Button>
                        <Button
                            type="primary"
                            onClick={() => {
                                onContinue();
                                onCancel();
                            }}
                        >
                            确定
                        </Button>
                    </>
                )}
            </div>
        </Modal>
    );
};

export default ForbiddenPrintRuleModal;
